import { FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useProyecto } from '../../../data/ProyectoContext';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const TemaProblema = () => {

    const { proyecto, setProyecto } = useProyecto();
    const {setPromptData} = useActividadesContext();

    const handleTemaProblema = (event) => {
        const { value } = event.target;
        setProyecto({...proyecto, tema_problematica: value
        });
        setPromptData((prevData) => ({
            ...prevData,
            tema_problematica: value 
          }));
      };

    
    return (
        <Grid xs={12} lg={12} md={12} >
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }} > Tema o problema a abordar * </Typography>
            <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}> ¿Cuál es el tema central o el problema específico que se desea explorar o resolver? </FormLabel>
           
            <TextField
                required
                id="contexto"
                placeholder='Comprender el impacto del cambio climático y desarrollar soluciones innovadoras para la comunidad.'
                name="contexto"
                fullWidth
                autoComplete="given-name"
                variant="outlined"
                value={proyecto.tema_problematica}
                onChange={handleTemaProblema}
                InputProps={{
                    sx: {
                        borderRadius:2,
                        mt:1,
                        mb: 3,
                        fontFamily: 'montserrat',
                        fontSize: '0.75rem',
                        color: '#005559',
                        '&::placeholder': {
                            color: '#005559',

                        },
                        '&:before': {
                            borderBottomColor: '#005559',

                        },
                        '&:after': {
                            borderBottomColor: '#005559',
                        },
                    }
                }}
            />
        </Grid>
    );
};

export default TemaProblema;




